export default __webpack_public_path__ + "static/media/pizzeria.c141e67f.jpg";